import { setProfile } from "../userSlice";
import { getPersonas, setDefaultPersonaId } from "./personaSlice";
export const personaMiddleware = (store) => (next) => async (action) => {
    action = await next(action);
    const dispatch = store.dispatch;
    // if setting the profile, get the personas and set the default persona
    if (setProfile.match(action) && action.payload) {
        const { default_persona_id } = action.payload;
        if (default_persona_id) {
            dispatch(setDefaultPersonaId(default_persona_id));
        }
        await dispatch(getPersonas());
    }
    return action;
};
